import { render, staticRenderFns } from "./Audio_1.vue?vue&type=template&id=5c9db4e4&scoped=true"
import script from "./Audio_1.vue?vue&type=script&lang=js"
export * from "./Audio_1.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c9db4e4",
  null
  
)

export default component.exports